
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import {
  NRCandidate,
  NRProject,
  NRProjectCase,
  NRProjectShortVideoCase
} from "@/lib/model/NRXQ/candidate";
import NRProjectCaseEdit from "./nr-project-case-edit-h5.vue";
import request from "@/lib/request/request";
import { NRClientType } from "@/lib/model/NRXQ/nr";

@Component({
  components: { NRProjectCaseEdit }
})
export default class NRProjectEdit extends Vue {
  @Prop({
    type: NRCandidate,
    default: () => {
      return new NRCandidate();
    }
  })
  cv!: NRCandidate;
  @Prop({ type: Boolean, default: true }) edit!: boolean;
  @Prop() atsCvId!: any;
  @Prop({ type: String, default: NRClientType.NRClientTypeAdmin })
  clientType!: string;

  NRProjectFormItemType = {
    INPUT: "input",
    MULTI_LINK: "multi_link",
    FILE: "file",
    IMG_LIST: "img_list",
    VIDEO: "video",
    SELECT: "select",
    CASCADER: "cascader",
    MULTI_CASCADER: "multi_cascader",
    TIME_DURING: "time_during"
  };

  lastWorkForm = [
    // {
    //   name: "上一份工资情况",
    //   key: "salary",
    //   type: this.NRProjectFormItemType.INPUT,
    // },
    {
      name: "公司名称",
      key: "companyName",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "底薪",
      key: "salaryBasic",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "提成",
      key: "salaryExtra",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "是否短期（一个月内）外地操盘项目",
      key: "workOut",
      type: this.NRProjectFormItemType.SELECT,
      options: [
        { key: "是", name: "是" },
        { key: "否", name: "否" }
      ]
    }
  ];

  expectWorkForm = [
    // {
    //   name: "这一份工资期望",
    //   key: "salary",
    //   type: this.NRProjectFormItemType.INPUT,
    // },
    {
      name: "公司名称",
      key: "companyName",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "底薪",
      key: "salaryBasic",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "提成",
      key: "salaryExtra",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "是否接受短期（一个月内）外地操盘项目",
      key: "workOut",
      type: this.NRProjectFormItemType.SELECT,
      options: [
        { key: "是", name: "是" },
        { key: "否", name: "否" }
      ]
    }
  ];

  caseForm = [
    {
      name: "案例账号名称",
      key: "name",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "抖音号",
      key: "douyinId",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "账号类目",
      key: "type",
      type: this.NRProjectFormItemType.CASCADER,
      options: []
    },
    {
      name: "带货类目",
      key: "saleType",
      type: this.NRProjectFormItemType.CASCADER,
      options: []
    },
    {
      name: "案例运营时间",
      key: "duration",
      type: this.NRProjectFormItemType.TIME_DURING
    },
    // {
    //   name: "案例截图",
    //   key: "screenshotUrl",
    //   type: this.NRProjectFormItemType.FILE,
    //   maxSize: 50,
    //   fileTypeLimit: ["png", "jpg", "bmp", "jpeg"]
    // },
    {
      name: "案例的第三方平台链接",
      key: "thirdUrl",
      type: this.NRProjectFormItemType.INPUT
    },
    // {
    //   name: "案例录屏链接列表",
    //   key: "videoUrlList",
    //   type: this.NRProjectFormItemType.MULTI_LINK
    // },
    // {
    //   name: "录屏视频链接",
    //   key: "outVideoUrl",
    //   type: this.NRProjectFormItemType.INPUT
    // },
    {
      name: "是否带货",
      key: "isSale",
      type: this.NRProjectFormItemType.SELECT,
      options: [
        { key: "是", name: "是" },
        { key: "否", name: "否" }
      ]
    },
    {
      name: "单月最高GMV",
      key: "maxGmvMonth",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "单场最高GMV",
      key: "maxGmv",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "是否是0到1起盘",
      key: "isStart",
      type: this.NRProjectFormItemType.SELECT,
      options: [
        { key: "是", name: "是" },
        { key: "否", name: "否" }
      ]
    }
  ];

  videoCaseForm = [
    {
      name: "账号类目",
      key: "type",
      type: this.NRProjectFormItemType.CASCADER,
      options: []
    },
    {
      name: "带货类目",
      key: "saleType",
      type: this.NRProjectFormItemType.CASCADER,
      options: []
    },
    {
      name: "时间(发布日期)",
      key: "publishData",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "短视频",
      key: "videoUrl",
      type: this.NRProjectFormItemType.FILE,
      maxSize: 1024,
      fileTypeLimit: []
    },
    {
      name: "链接",
      key: "outVideoUrl",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "播放量",
      key: "playNumber",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "点赞",
      key: "likeNumber",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "评论",
      key: "commentNumber",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "转发",
      key: "shareNumber",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "时长",
      key: "duration",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "完播率",
      key: "finishPercent",
      type: this.NRProjectFormItemType.INPUT
    },
    {
      name: "小黄车销售额",
      key: "salesVolume",
      type: this.NRProjectFormItemType.INPUT
    }
  ];

  created() {
    request.post("aiExam/atsPublic/typeOptions").then((res: any) => {
      if (res.data.code == 0) {
        const typeOptions = [];
        const saleTypeOptions = [];

        for (const index in res.data.data.typeOptions.keyList1) {
          const item = {
            value: res.data.data.typeOptions.keyList1[index],
            label: res.data.data.typeOptions.keyList1[index],
            children: []
          };

          const children: any[] = [];
          for (const subOriItem of res.data.data.typeOptions.keyList2[index]) {
            const subItem = {
              value: subOriItem,
              label: subOriItem
            };
            children.push(subItem);
          }
          if (children.length > 0) (item.children as any) = children;
          else delete item.children;
          typeOptions.push(item);
        }

        for (const index in res.data.data.saleTypeOptions.keyList1) {
          const item = {
            value: res.data.data.saleTypeOptions.keyList1[index],
            label: res.data.data.saleTypeOptions.keyList1[index],
            children: []
          };

          const children: any[] = [];
          for (const subOriItem of res.data.data.saleTypeOptions.keyList2[
            index
          ]) {
            const subItem = {
              value: subOriItem,
              label: subOriItem
            };
            children.push(subItem);
          }
          if (children.length > 0) (item.children as any) = children;
          else delete item.children;
          saleTypeOptions.push(item);
        }

        (this.caseForm[2] as any)["options"] = typeOptions;
        (this.caseForm[3] as any)["options"] = saleTypeOptions;
        (this.videoCaseForm[0] as any)["options"] = typeOptions;
        (this.videoCaseForm[1] as any)["options"] = saleTypeOptions;
      }
    });
  }
  mounted() {
    //
  }
  delCase(i: number) {
    this.cv.nrProject.caseList.splice(i, 1);
  }
  addCase() {
    this.cv.nrProject.caseList.push(new NRProjectCase());
  }
  delVideoCase(i: number) {
    this.cv.nrProject.shortVideoList.splice(i, 1);
  }
  addVideoCase() {
    this.cv.nrProject.shortVideoList.push(new NRProjectShortVideoCase());
  }
  getMultiInputShowArray(value: string) {
    return value.split(/,|，|。|\n|/);
  }

  get showSaveButton() {
    return this.clientType == NRClientType.NRClientTypeCandidate;
  }
  async saveProject() {
    let url = "";
    const param = {
      nrProject: this.cv.nrProject
    };
    if (this.clientType == NRClientType.NRClientTypeCandidate) {
      url = "/aiExam/atsPublic/cvSaveNrProject";
      param["atsCvOutId"] = this.atsCvId;
    } else if (this.clientType == NRClientType.NRClientTypeAdmin) {
      url = "/aiExam/atsAdmin/cvSaveNrProject";
      param["atsCvId"] = this.atsCvId;
    }
    try {
      const resp = await request.post(url, param);
      if (resp.data.code === 0) {
        if (this.showSaveButton) {
          this.$message.success("保存成功");
        }
        return true;
      }
    } catch (e) {
      console.log(e);
    }
    return false;
  }
}
